import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import TableServerSideProvider from '~COMPONENTS/tableServerSide/TableServerSideContext';
import DepartmentsList from './DepartmentsList';

import { columnSortModifiersDepartments, getColumnFilterModifiersDepartments } from './departmentColumns';

import { getAllAccounts } from './actions';

import { getAccounts } from './selectors';

export const DepartmentRoutes = () => {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();

  useEffect(() => {
    dispatch(getAllAccounts());
  }, []);

  const allAccounts = Object.values(useSelector(getAccounts));

  const columnFilterModifiersDepartments = getColumnFilterModifiersDepartments(allAccounts);

  return (
    <Switch>
      <Route exact path={path}>
        <TableServerSideProvider
          tableId='departments'
          columnSortModifiers={columnSortModifiersDepartments}
          columnFilterModifiers={columnFilterModifiersDepartments}
        >
          <DepartmentsList />
        </TableServerSideProvider>
      </Route>
    </Switch>
  );
};

export default DepartmentRoutes;
